export const TAB_GENERAL = 'POST_SETTINGS_TAB_GENERAL';
export const TAB_SEO = 'POST_SETTINGS_TAB_SEO';
export const TAB_CATEGORIES = 'POST_SETTINGS_TAB_CATEGORIES';
